// Deterministic FNV-1a hash of (seed, key) into [0, 1). Stable across runs so a recipient always
// lands in the same arm; the seed keeps cohorts from repeating across experiments, holdouts and splits.
const splitBucket = (key, seed) => {
  let hash = 0x811c9dc5;
  const input = `${seed}:${key}`;
  for (let i = 0; i < input.length; i += 1) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return ((hash >>> 0) % 1000000) / 1000000;
};

module.exports = {
  splitBucket
};
